import React, { useEffect, useState } from "react";

const SubmitMessage = ({ survey, submittedData }) => {
    const [redirectTimer, setRedirectTimer] = useState(null);
    const [timeLeft, setTimeLeft] = useState(0);
    const [initialTime, setInitialTime] = useState(0);

    // Cleanup timer on unmount
    useEffect(() => {
        return () => {
            if (redirectTimer) {
                clearInterval(redirectTimer);
            }
        };
    }, [redirectTimer]);

    const startRedirectTimer = (redirectTime) => {
        let timeLeft = redirectTime || 5; // Default to 5 seconds if not specified
        setTimeLeft(timeLeft);
        setInitialTime(timeLeft); // Store the initial time for progress calculation

        const timer = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    handleRedirect();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        setRedirectTimer(timer);
    };

    const handleRedirect = () => {
        if (survey.redirectUrl) {
            window.location.href = survey.redirectUrl;
        }
    };

    // Calculate progress percentage for smooth progress bar
    const calculateProgress = () => {
        if (initialTime === 0) return 100;
        return ((initialTime - timeLeft) / initialTime) * 100;
    };

    // Start redirect timer when component mounts if needed
    useEffect(() => {
        if (survey.redirectUrl && survey.redirectTimeAfterMessage && survey.redirectTimeAfterMessage > 0) {
            startRedirectTimer(survey.redirectTimeAfterMessage);
        } else if (survey.redirectUrl) {
            // Immediate redirect after a brief delay
            setTimeout(() => {
                handleRedirect();
            }, 100);
        }
    }, [survey.redirectUrl, survey.redirectTimeAfterMessage]);

    return (
        <div className="container py-4">
            <div className="row">
                {/* Survey End Message - 70% */}
                <div className="col-8">
                    <div className="card">
                        <div className="card-body text-center">
                            {/* Display thank you message HTML content */}
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: survey.messageAfterComplete ||
                                        "<h3>Thank you for completing the survey!</h3><p>Your responses have been recorded.</p>"
                                }}
                            />

                            {/* Show redirect timer if applicable */}
                            {survey.redirectUrl && survey.redirectTimeAfterMessage && survey.redirectTimeAfterMessage > 0 && (
                                <div className="mt-3">
                                    <p className="text-muted">
                                        Redirecting in {timeLeft} second{timeLeft !== 1 ? 's' : ''}...
                                    </p>
                                    <div className="progress" style={{ height: '8px' }}>
                                        <div
                                            className="progress-bar progress-bar-striped progress-bar-animated"
                                            role="progressbar"
                                            style={{
                                                width: `${calculateProgress()}%`,
                                                transition: 'width 0.5s ease-in-out'
                                            }}
                                            aria-valuenow={calculateProgress()}
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                        ></div>
                                    </div>
                                    <button
                                        className="btn btn-primary mt-3"
                                        onClick={handleRedirect}
                                    >
                                        Click here to redirect immediately
                                    </button>
                                </div>
                            )}

                            {/* Show immediate redirect message */}
                            {survey.redirectUrl && (!survey.redirectTimeAfterMessage || survey.redirectTimeAfterMessage <= 0) && (
                                <div className="mt-3">
                                    <div className="spinner-border text-primary mb-2" role="status">
                                        <span className="visually-hidden">Redirecting...</span>
                                    </div>
                                    <p className="text-muted mb-2">Redirecting...</p>
                                    <button
                                        className="btn btn-primary"
                                        onClick={handleRedirect}
                                    >
                                        Click here if you are not redirected automatically
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Submitted Data - 30% */}
                <div className="col-4">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="mb-0">Submitted Data</h5>
                        </div>
                        <div className="card-body">
                            <pre style={{ fontSize: '12px', maxHeight: '500px', overflow: 'auto' }}>
                                {JSON.stringify(submittedData, null, 2)}
                            </pre>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubmitMessage;